import { render, staticRenderFns } from "./Proprietarios.vue?vue&type=template&id=de11b71e"
import script from "./Proprietarios.vue?vue&type=script&lang=js"
export * from "./Proprietarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports